import { Logger, LoggerFactory } from './../../../core/logger.service';
import { LanguageService } from './../../../core/language.service';
import { TitleService } from './../../../core/title.service';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SiteSpecific, UserSession } from 'app/core/site-specific.base';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'navigation-sub-item',
  templateUrl: './navigation-sub-item.component.html',
  styleUrls: ['navigation-sub-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NavigationSubItemComponent extends SiteSpecific {
  private readonly logger: Logger;
  public isSelected: boolean;
  public label: string;
  public activeUrl: string;
  public isProfilesSubmenuItem: boolean;
  public isSurveysSubmenuItem: boolean;
  public _url: string;
  public isButton = false;
  public currrentCampaignPage: string;

  @Input() public set url(url: string) {
    this._url = url;
    this.isButton = ['/campaigns/create/templates', '/automations/create'].indexOf(url) !== -1;
  }

  public get url(): string {
    return this._url;
  }

  @Input() public query: any;
  @Input() public translationKey: string;
  @Input() public isBetaItem = false;
  @Input() public adminOnly: boolean;
  @Input() isNew: boolean;
  @Input() public showUpgradeTag: boolean;
  @Input() public currentPage: boolean;
  @Input() public dataTest: string;

  constructor(
    private titleService: TitleService,
    private languageService: LanguageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    protected readonly userSession: UserSession,
    protected loggerFactory: LoggerFactory,
  ) {
    super(userSession, loggerFactory);
    this.logger = loggerFactory.get('NavigationItemComponent');
  }

  protected async onSiteChanged() {
    this.ensureInputs();
    this.initTitleService();
    this.label = await this.languageService.translateAsync(this.translationKey);
    this.fetchCurrrentCampaignPage();
  }

  private initTitleService(): void {
    this.handleRouteChange();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(async () => await this.handleRouteChange());
  }

  private async handleRouteChange() {
    this.isProfilesSubmenuItem =
      this.url.startsWith('/profiles/import') ||
      this.url.startsWith('/profiles/delete') ||
      this.url.startsWith('/profiles/contact-fields');
    this.isSurveysSubmenuItem =
      this.url.startsWith('/campaigns/surveys/nps') || this.url.startsWith('/campaigns/surveys/csat');
    this.activeUrl = this.router.routerState.snapshot.url;
    const activePath = this.activeUrl.split('?')[0].split('#')[0];
    this.isSelected = this.url.startsWith('/backoffice/') ? activePath === this.url : this.activeUrl.endsWith(this.url);
  }

  private ensureInputs() {
    if (!this.url) {
      this.logger.error(`No url is given for the item.\nThis:${this.toString()}`);
    }
    // if (!this.icon) {
    //     this.logger.error(`No icon is given for the item.\nThis:${this.toString()}`);
    // }
    if (!this.translationKey) {
      this.logger.error(`No translationKey is given for the item.\nThis:${this.toString()}`);
    }
  }

  private toString(): string {
    return `Url: "${this.url}"–Translation key:"${this.translationKey}"`;
  }

  private fetchCurrrentCampaignPage() {
    if (this.url?.startsWith('/campaigns/')) {
      this.currrentCampaignPage = this.url.slice(11);
    }
  }
}
